export const L10N = {
  ACTION_MORE_INFO: { id: 'common.action.more_info' },

  LABEL_GENERIC_NAME: { id: 'common.label.accommodation' },
  LABEL_PRIVACY_DISCLAIMER: { id: 'core.label.privacy_disclaimer' },
};
